import { message } from 'antd';

// Local Deps
import { makeGraphQLRequest } from '../utils/requestUtils';

/* ------------------------------------------
  ADD MATCH SETTINGS
--------------------------------------------*/
// export async function addMatchSettings(
//   {
//     materials = null,
//     methods = null,
//     minimumQuantity = null,
//     minimumEstimatedCost = null,
//   },
//   userId,
// ) {
//   // Format Query
//   const query = `mutation AddMatchSettings(
//     $criteria: SolicitationCriteria1,
//     $userId: ID
//   ) {
//       addMatchSetting(matchSettingCriteria: $criteria, userId: $userId) {
//         materials
//         methods
//         minimumQuantity
//         minimumEstimatedCost
//       }
//     }`;

//   // Variables
//   const variables = {
//     criteria: {
//       materials,
//       methods,
//       minimumQuantity,
//       minimumEstimatedCost,
//     },
//     userId,
//   };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });

//   return response;
// }

/* ------------------------------------------
  DELETE MATCH SETTINGS
--------------------------------------------*/
// export async function deleteMatchSettings(idx, userId) {
//   // Format Query
//   const query = `mutation DeleteMatchSettings(
//     $userId: ID
//   ) {
//       deleteMatchSetting(matchSettingIndex: $idx, userId: $userId) {
//         materials
//         methods
//         minimumQuantity
//         minimumEstimatedCost
//       }
//     }`;

//   // Variables
//   const variables = { idx, userId };

//   const response = await makeGraphQLRequest({
//     query,
//     variables,
//   });

//   return response;
// }

/* ------------------------------------------
  UPDATE MATCH SETTINGS
--------------------------------------------*/
export async function updateMatchSettings(
  {
    methods = [],
    materials = [],
    minimumQuantity = 0,
    minimumEstimatedCost = 0,
  },
  userId,
) {
  // Format Query
  const query = `mutation updateMatchSettings(
    $criteria: MatchSettingInput,
    $userId: ID
  ) {
      updateMatchSetting(
        matchSettingCriteria: $criteria, 
        userId: $userId
      ) {
        materials
        methods
        minimumQuantity
        minimumEstimatedCost
      }
    }`;
  // Variables
  const variables = {
    criteria: {
      methods,
      materials,
      minimumQuantity,
      minimumEstimatedCost,
    },
    userId,
  };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  message.success('Your Bid Match Settings have been successfully updated.', 2);
  return response;
}

export default {
  // addMatchSettings,
  // deleteMatchSettings,
  updateMatchSettings,
};



// WEBPACK FOOTER //
// ./src/graphql/matchSettings.js